const unitTypes = [
  { header: 'Crew' },
  { value: 'CREW_TRANS', text: 'Crew Transport' },
  { header: 'Engine' },
  { value: 'ENGINE_STRUCT', text: 'Engine (Structural)' },
  { value: 'ENGINE_WUI', text: 'Engine (Wildland Interface, includes brush pumpers/brush trucks)' },
  { header: 'Boat' },
  { value: 'BOAT', text: 'Fire / Rescue Boat, Small (Craft Length of < 20 feet)' },
  { value: 'BOAT_LARGE', text: 'Fire Boat, Large (Craft Length of 20+ feet)' },
  { header: 'Ladder, Platform' },
  { value: 'LADDER_SMALL', text: 'Ladder or Truck, Rear or Mid-Mount Ladder < 75\' No Suppression Capability' },
  { value: 'LADDER_QUINT', text: 'Ladder or Truck, Rear or Mid-Mount Ladder < 75\' Suppression Capable' },
  { value: 'LADDER_TALL', text: 'Ladder or Truck, Rear or Mid-Mount Ladder 75\'+ No Suppression Capability' },
  { value: 'QUINT_TALL', text: 'Ladder or Truck, Rear or Mid-Mount Ladder 75\'+ Suppression Capable' },
  { value: 'PLATFORM', text: 'Elevated Platform, Rear or Mid-Mount Ladder > 75\' No Suppression Capability' },
  { value: 'PLATFORM_QUINT', text: 'Elevated Platform, Rear or Mid-Mount Ladder > 75\' with Suppression Capability' },
  { value: 'LADDER_TILLER', text: 'Tractor-drawn Aerial unit' },
  { header: 'Helicopter' },
  { value: 'HELO_GENERAL', text: 'Helicopter, Multiuse' },
  { value: 'HELO_FIRE', text: 'Helicopter, Fire Suppression' },
  { value: 'HELO_RESCUE', text: 'Helicopter, Rescue/EMS' },
  { header: 'Unmanned Aerial' },
  { value: 'UAS_FIRE', text: 'Drone/UAV - Fire Suppression' },
  { value: 'UAS_RECON', text: 'Drone/UAV - Recon or Situational Awareness' },
  { header: 'Other Aerial' },
  { value: 'AIR_TANKER', text: 'Fixed Wing, Fire Suppression' },
  { value: 'AIR_EMS', text: 'Fixed Wing, EMS' },
  { value: 'AIR_RECON', text: 'Fixed Wing, Recon or Other' },
  { header: 'Medical' },
  { value: 'ALS_AMB', text: 'Ambulance, ALS' },
  { value: 'BLS_AMB', text: 'Ambulance, BLS' },
  { value: 'EMS_NOTRANS', text: 'EMS Response Vehicle (Non-Transport)' },
  { value: 'EMS_SUPV', text: 'EMS Supervisor' },
  { value: 'MAB', text: 'Medical Ambulance Bus (MAB)' },
  { header: 'HazMat (Hazardous Materials)' },
  { value: 'HAZMAT', text: 'Hazardous Materials Unit' },
  { value: 'DECON', text: 'Decontamination Unit' },
  { header: 'Rescue' },
  { value: 'RESCUE_HEAVY', text: 'Rescue Unit, Multi-Function, Heavy' },
  { value: 'RESCUE_MEDIUM', text: 'Rescue Unit, Multi-Function, Medium' },
  { value: 'RESCUE_LIGHT', text: 'Rescue Unit, Multi-Function, Light' },
  { value: 'RESCUE_USAR', text: 'Rescue Unit, US&R' },
  { value: 'RESCUE_WATER', text: 'Rescue Unit, Water Rescue' },
  { header: 'Air Support' },
  { value: 'SCBA', text: 'SCBA Support Unit' },
  { value: 'AIR_LIGHT', text: 'Air and Light Unit' },
  { header: 'All Terrain' },
  { value: 'ATV_EMS', text: 'All Terrain Vehicle, EMS/Rescue' },
  { value: 'ATV_FIRE', text: 'All Terrain Vehicle, Fire Suppression' },
  { header: 'Mobile' },
  { value: 'MOBILE_ICP', text: 'Mobile Command Post' },
  { value: 'MOBILE_COMMS', text: 'Mobile Communications Equipment' },
  { header: 'Other' },
  { value: 'POV', text: 'Privately Owned Vehicle' },
  { value: 'CHIEF_STAFF_COMMAND', text: 'Chief/Staff/Command Officer' },
  { value: 'ARFF', text: 'ARFF Response Vehicle' },
  { value: 'FOAM', text: 'Foam Tender' },
  { value: 'TENDER', text: 'Water Tender/Tanker' },
  { value: 'CREW', text: 'Hand Crew' },
  { value: 'REHAB', text: 'Rehabilitation or Canteen Unit' },
  { value: 'DOZER', text: 'Bulldozer / Dozer' },
  { value: 'OTHER_GROUND', text: 'Other Ground Equipment' },
  { value: 'INVEST', text: 'Fire investigation Unit' },
  { value: 'UTIL', text: 'General Purpose/Utility Unit' },
];

export default unitTypes;
